const defaultProps = {
    hideOnError: false,
    fallbackImage: "/themes/gd5/images/logo.svg",
    errorClassName: 'error',
    errorStyle: {},
    style: {},
}

const Image = React.forwardRef((props, ref) => {
    const {src, title, fallbackImage, className, errorClassName, errorStyle, style, hideOnError, ...restProps} = props
    const [error, setError] = React.useState(!src)

    React.useEffect(() => {
        setError(!src)
    }, [src])

    if (error && hideOnError)
        return

    return (
        <img ref={ref}
             src={error ? fallbackImage : src}
             className={cn(className, error && errorClassName)}
             onError={() => setError(true)}
             alt={title || ''}
             style={Object.assign({}, style, error && errorStyle)}
             {...restProps}
         />
    )
})

Image.defaultProps = defaultProps

export default Image
